// extracted by css-extract-rspack-plugin
export default {"flex":"flex-RvkoRx","root":"root-PHdvSJ flex-RvkoRx","content":"content-qg04Iy flex-RvkoRx"};